var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createTextVNode as _createTextVNode, renderSlot as _renderSlot, Transition as _Transition, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = { class: "itinerary-fields__trip-type" };
var _hoisted_2 = {
    key: 0,
    class: "itinerary-fields__airport-lookup"
};
var _hoisted_3 = {
    key: 1,
    class: "itinerary-fields__multi-city"
};
var _hoisted_4 = {
    key: 0,
    class: "itinerary-fields__multi-city__remove"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-delete-fill icon--sm icon-color--red",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_7 = [
    _hoisted_6
];
var _hoisted_8 = {
    key: 0,
    class: "itinerary-fields__second-row"
};
var _hoisted_9 = {
    key: 0,
    class: "itinerary-fields__add-flight"
};
var _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", { class: "itinerary-fields__add-flight__button__icon" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "icon icon-color--white icon-plus icon--sm",
        "aria-hidden": "true"
    })
], -1 /* HOISTED */);
var _hoisted_11 = {
    key: 1,
    class: "itinerary-fields__cabin-input"
};
var _hoisted_12 = {
    key: 2,
    class: "itinerary-fields__depart-return-picker"
};
import { ref, computed, watch, inject, onMounted } from 'vue';
import { watchDebounced } from '@vueuse/core';
import CabinInput from '../CabinInput/CabinInput.vue';
import AirportLookup from '../AirportLookup/AirportLookup.vue';
import DropdownSelect from '../DropdownSelect/DropdownSelect.vue';
import DepartReturnPicker from '../DepartReturnPicker/DepartReturnPicker.vue';
import createAmadeusBestPricesRequest from '../../lib/createAmadeusBestPricesRequest';
import optiClient from '../../services/api';
import dayjs from 'dayjs';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ItineraryFieldsComponent',
    props: {
        size: { default: 'small' },
        showDates: { type: Boolean, default: true },
        showCabinClass: { type: Boolean, default: true },
        conditionalSecondRow: { type: Boolean, default: true },
        conditionalCabinClass: { type: Boolean, default: true },
        allowMultiCity: { type: Boolean, default: true },
        isStuck: { type: Boolean },
        showPrices: { type: Boolean, default: true },
        itineraries: { default: function () { return [{}, {}]; } },
        passengerAndCabinClass: { default: function (props) { var _a; return (_a = props.passengerAndCabinClass) !== null && _a !== void 0 ? _a : ({ adults: 1, cabin: 'economy', youth: 0, child: 0, infant: 0 }); } },
        tripType: {}
    },
    emits: ["update:itineraries", "update:passengerAndCabinClass", "update:tripType"],
    setup: function (__props, _a) {
        var _this = this;
        var _b;
        var emit = _a.emit;
        var props = __props;
        ;
        var tripOptions = [
            { label: 'Return', value: 'return' },
            { label: 'One way', value: 'oneway' },
        ];
        if (props.allowMultiCity) {
            tripOptions.push({ label: 'Multi-city', value: 'multi-city' });
        }
        var getInitialTripType = function () {
            if (props.tripType)
                return props.tripType;
            if (props.itineraries.length === 1)
                return tripOptions[1];
            if (props.itineraries.length === 2) {
                if (props.itineraries[0].toAirportCode && props.itineraries[0].toAirportCode === props.itineraries[1].fromAirportCode)
                    return tripOptions[2];
            }
            return tripOptions[0];
        };
        var cmsProps = inject('cms-props');
        var dropdownTripType = ref();
        var tripLengthRef = ref(15);
        var itinerariesRef = ref(props.itineraries);
        var passengerAndCabinClassRef = ref(props.passengerAndCabinClass);
        var displayMonth = ref(dayjs().add(1, 'day').toDate());
        var apiPrices = ref();
        var fareFamilies = (_b = inject('amadeus-fare-families')) !== null && _b !== void 0 ? _b : ['CFFECOBIZ', 'CFFBIZ'];
        var tripTypeRef = computed(function () { var _a; return (_a = dropdownTripType.value) === null || _a === void 0 ? void 0 : _a.value; });
        onMounted(function () {
            var _a, _b;
            var initialTripType = getInitialTripType();
            dropdownTripType.value = initialTripType;
            var initialDepartureDate = initialTripType.value !== 'multi-city' ? (_b = (_a = props.itineraries) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.departureDate : undefined;
            if (initialDepartureDate)
                displayMonth.value = new Date(initialDepartureDate);
        });
        watch(tripTypeRef, function (value, oldValue) {
            var _a, _b, _c;
            if (value === oldValue || !oldValue)
                return;
            if (value === 'multi-city') {
                itinerariesRef.value[0] = (_a = itinerariesRef.value[0]) !== null && _a !== void 0 ? _a : {};
                itinerariesRef.value.length = 1;
            }
            else if (value === 'oneway') {
                itinerariesRef.value[0] = (_b = itinerariesRef.value[0]) !== null && _b !== void 0 ? _b : {};
                itinerariesRef.value[1] = { ignore: true };
                itinerariesRef.value.length = 2;
            }
            else {
                itinerariesRef.value[0] = (_c = itinerariesRef.value[0]) !== null && _c !== void 0 ? _c : {};
                itinerariesRef.value[1] = { ignore: false };
                itinerariesRef.value.length = 2;
            }
            itinerariesRef.value = __spreadArray([], itinerariesRef.value, true);
        }, { immediate: true });
        watch(function () { return itinerariesRef.value[0]; }, function (itinerary) {
            var _a, _b;
            if (tripTypeRef.value === 'return' && ((_a = itinerary.fromAirport) === null || _a === void 0 ? void 0 : _a.locIATA) && ((_b = itinerary.toAirport) === null || _b === void 0 ? void 0 : _b.locIATA) && itinerariesRef.value[1]) {
                itinerariesRef.value[1].toAirport = itinerariesRef.value[0].fromAirport;
                itinerariesRef.value[1].fromAirport = itinerariesRef.value[0].toAirport;
            }
        }, { deep: true });
        watch(passengerAndCabinClassRef, function (value) {
            emit('update:passengerAndCabinClass', value);
        });
        watch(function () { return props.passengerAndCabinClass; }, function (value) {
            passengerAndCabinClassRef.value = value;
        }, { deep: true });
        watch(dropdownTripType, function (value) {
            emit('update:tripType', value);
        });
        watch(function () { return props.tripType; }, function (value) {
            dropdownTripType.value = value;
        }, { deep: true });
        watchDebounced(itinerariesRef, function (value) {
            emit('update:itineraries', value);
        }, { deep: true, debounce: 300, maxWait: 500 });
        watch(function () { return props.itineraries; }, function (value) {
            itinerariesRef.value = value;
        }, { deep: true });
        var setDisplayMonth = function (month) {
            displayMonth.value = month;
        };
        var setOneWay = function (value) {
            dropdownTripType.value = tripOptions[value ? 1 : 0];
        };
        var pricesRequest = computed(function () {
            if (!itinerariesRef.value[0].fromAirport || !itinerariesRef.value[0].toAirport || !displayMonth.value || tripTypeRef.value === 'multi-city' || !props.showDates)
                return null;
            return createAmadeusBestPricesRequest({
                originLocationCode: itinerariesRef.value[0].fromAirport.locIATA,
                destinationLocationCode: itinerariesRef.value[0].toAirport.locIATA,
                departureDateTime: itinerariesRef.value[0].departureDate ? new Date(itinerariesRef.value[0].departureDate) : displayMonth.value,
                tripDuration: tripTypeRef.value === 'oneway' ? undefined : itinerariesRef.value[1].departureDate ? dayjs(itinerariesRef.value[1].departureDate).diff(itinerariesRef.value[0].departureDate, 'days') + 1 : tripLengthRef.value,
                rangeOfDeparture: itinerariesRef.value[0].departureDate ? undefined : 62,
                durationFlexibility: itinerariesRef.value[0].departureDate ? undefined : 1,
                fareFamilies: fareFamilies,
            });
        });
        var getFlightPrices = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, optiClient.bookings.postApiV1BookingsFlightsSearch(pricesRequest.value)];
                    case 1:
                        res = _a.sent();
                        apiPrices.value = res;
                        console.log('get', apiPrices.value);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var calculateMonthsDifference = function (departureDate) {
            if (departureDate) {
                var currentDate = dayjs();
                var departureDateObj = dayjs(departureDate, 'DD MMM YY');
                var monthsDifference = currentDate.diff(departureDateObj, 'month') * -1;
                return monthsDifference;
            }
            return 0;
        };
        watchDebounced(function () { return pricesRequest.value; }, function (newValue) {
            if (newValue) {
                getFlightPrices();
            }
        }, { debounce: 300, maxWait: 500 });
        function addMultiCityFlight() {
            itinerariesRef.value.push({ ignore: false });
        }
        function removeMultiCityFlight(index) {
            itinerariesRef.value.splice(index, 1);
        }
        return function (_ctx, _cache) {
            var _a, _b;
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    'itinerary-fields',
                    'itinerary-fields--' + _ctx.size,
                    {
                        'itinerary-fields--stuck': _ctx.isStuck,
                        'itinerary-fields--multi-city': tripTypeRef.value === 'multi-city'
                    },
                ])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(DropdownSelect, {
                        modelValue: dropdownTripType.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((dropdownTripType).value = $event); }),
                        "dropdown-title": (_b = (_a = _unref(cmsProps)) === null || _a === void 0 ? void 0 : _a.tripTypeLabel.value) !== null && _b !== void 0 ? _b : 'Trip',
                        "options-array": tripOptions
                    }, null, 8 /* PROPS */, ["modelValue", "dropdown-title"])
                ]),
                (tripTypeRef.value !== 'multi-city')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(AirportLookup, {
                            "airport-from": itinerariesRef.value[0].fromAirport,
                            "onUpdate:airportFrom": _cache[1] || (_cache[1] = function ($event) { return ((itinerariesRef.value[0].fromAirport) = $event); }),
                            "airport-to": itinerariesRef.value[0].toAirport,
                            "onUpdate:airportTo": _cache[2] || (_cache[2] = function ($event) { return ((itinerariesRef.value[0].toAirport) = $event); })
                        }, null, 8 /* PROPS */, ["airport-from", "airport-to"])
                    ]))
                    : _createCommentVNode("v-if", true),
                (tripTypeRef.value === 'multi-city')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_TransitionGroup, { name: "list" }, {
                            default: _withCtx(function () { return [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itinerariesRef.value, function (itinerary, index) {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "itinerary-fields__multi-city__row"
                                    }, [
                                        _createVNode(AirportLookup, {
                                            "airport-from": itinerary.fromAirport,
                                            "onUpdate:airportFrom": function ($event) { return ((itinerary.fromAirport) = $event); },
                                            "airport-to": itinerary.toAirport,
                                            "onUpdate:airportTo": function ($event) { return ((itinerary.toAirport) = $event); }
                                        }, null, 8 /* PROPS */, ["airport-from", "onUpdate:airportFrom", "airport-to", "onUpdate:airportTo"]),
                                        _createVNode(DepartReturnPicker, {
                                            "depart-value": itinerary.departureDate,
                                            "onUpdate:departValue": function ($event) { return ((itinerary.departureDate) = $event); },
                                            name: 'departureDate' + index,
                                            "show-prices": false,
                                            "show-one-way": false,
                                            "one-way": "",
                                            "min-date": (index > 0 && itinerariesRef.value[index - 1].departureDate
                                                ? (_unref(dayjs)(itinerariesRef.value[index - 1].departureDate).endOf('month').isSame(itinerariesRef.value[index - 1].departureDate, 'day')
                                                    ? _unref(dayjs)(itinerariesRef.value[index - 1].departureDate).endOf('month').add(1, 'day').toDate()
                                                    : new Date(itinerariesRef.value[index - 1].departureDate))
                                                : _unref(dayjs)().startOf('day').toDate()),
                                            "max-date": index < itinerariesRef.value.length - 1 && itinerariesRef.value[index + 1].departureDate
                                                ? new Date(itinerariesRef.value[index + 1].departureDate)
                                                : index > 0 && itinerariesRef.value[index - 1].departureDate
                                                    ? _unref(dayjs)(itinerariesRef.value[index - 1].departureDate).add(361, 'day').toDate()
                                                    : _unref(dayjs)().startOf('day').add(361, 'day').toDate(),
                                            "onUpdate:displayMonth": _cache[3] || (_cache[3] = function (value) { return setDisplayMonth(value); })
                                        }, null, 8 /* PROPS */, ["depart-value", "onUpdate:departValue", "name", "min-date", "max-date"]),
                                        (index === itinerariesRef.value.length - 1 && index !== 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createElementVNode("button", {
                                                    role: "button",
                                                    "aria-label": "Remove this flight",
                                                    class: "button button--text button--icon",
                                                    onClick: function ($event) { return (removeMultiCityFlight(index)); }
                                                }, _hoisted_7, 8 /* PROPS */, _hoisted_5)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]; }),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_Transition, { name: "row" }, {
                    default: _withCtx(function () { return [
                        (itinerariesRef.value[0].fromAirport && itinerariesRef.value[0].toAirport || !_ctx.conditionalSecondRow)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (tripTypeRef.value === 'multi-city')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        (itinerariesRef.value.length < 4)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                role: "button",
                                                "aria-label": "Add a multi-city flight to your itinerary",
                                                class: "itinerary-fields__add-flight__button",
                                                onClick: addMultiCityFlight
                                            }, [
                                                _hoisted_10,
                                                _createTextVNode(" Add Flight ")
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (_ctx.showCabinClass || (!_ctx.conditionalSecondRow && !_ctx.conditionalCabinClass))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createVNode(CabinInput, {
                                            modelValue: passengerAndCabinClassRef.value,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((passengerAndCabinClassRef).value = $event); })
                                        }, null, 8 /* PROPS */, ["modelValue"])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (tripTypeRef.value !== 'multi-city' && _ctx.showDates && itinerariesRef.value[1])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createVNode(DepartReturnPicker, {
                                            "depart-value": itinerariesRef.value[0].departureDate,
                                            "onUpdate:departValue": _cache[5] || (_cache[5] = function ($event) { return ((itinerariesRef.value[0].departureDate) = $event); }),
                                            "return-value": itinerariesRef.value[1].departureDate,
                                            "onUpdate:returnValue": _cache[6] || (_cache[6] = function ($event) { return ((itinerariesRef.value[1].departureDate) = $event); }),
                                            "trip-length": tripLengthRef.value,
                                            "onUpdate:tripLength": _cache[7] || (_cache[7] = function ($event) { return ((tripLengthRef).value = $event); }),
                                            name: "departReturn",
                                            "min-date": _unref(dayjs)().startOf('day').toDate(),
                                            "max-date": itinerariesRef.value[0].departureDate ? undefined : ((_unref(dayjs)(itinerariesRef.value[0].departureDate).add(361, 'day').toDate())),
                                            "show-prices": _ctx.showPrices,
                                            "api-prices": apiPrices.value,
                                            "one-way": tripTypeRef.value !== 'return',
                                            "onUpdate:oneWay": setOneWay,
                                            "onUpdate:displayMonth": _cache[8] || (_cache[8] = function (value) { return setDisplayMonth(value); })
                                        }, null, 8 /* PROPS */, ["depart-value", "return-value", "trip-length", "min-date", "max-date", "show-prices", "api-prices", "one-way"])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _renderSlot(_ctx.$slots, "default")
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]; }),
                    _: 3 /* FORWARDED */
                })
            ], 2 /* CLASS */));
        };
    }
});
